<template>
  <div>
    <v-divider />
    <v-layout row wrap mt-3>
      <v-flex pa-2 xs4 sm2 v-for="(wall, index) in walls" :key="index">
        <router-link
          :to="{ 
            name: 'artist.artwork.test', 
            params: { wallId: wall.id }, 
            query: {...$route.query, ...{userWall: wall.isUserWall}  } 
          }"
        >
          <v-img :src="wall.thumb" aspect-ratio="1" class="thumbnail" />
        </router-link>
      </v-flex>
      <v-flex pa-2 xs4 sm2 text-xs-center>
        <form enctype="multipart/form-data" novalidate>
          <div class="dropbox" :class="{'disabled': percentCompleted > -1}">
            <template v-if="percentCompleted < 0">
              <input
                ref="fileRef"
                type="file"
                multiple
                accept="image/png, image/jpeg"
                class="input-file"
                @change="onFileChange"
              />
              <p v-html="$t('ARTWORK.UPLOAD_TEST_WALL')"></p>
              <v-alert
                v-if="error"
                :value="true"
                type="error"
                dismissible
                @input="error = null"
              >{{ error }}</v-alert>
            </template>
            <v-progress-circular
              v-else
              color="black"
              :rotate="360"
              :size="100"
              :width="15"
              :value="percentCompleted"
            >{{ percentCompleted }}</v-progress-circular>
          </div>
        </form>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { walls, defaultWall } from "@/config";
import { convertToBase64 } from "@/utils/FileHelpers";

export default {
  props: ["sizeRange"],
  data() {
    return {
      percentCompleted: -1,
      error: null,
      configwalls: walls,
    };
  },

  computed: {
    walls() {
      const walls = this.configwalls.filter(
        (wall) => wall.sizeRange === this.sizeRange
      );
      // Manually add white wall, which can be included in any artworks type
      walls.unshift(defaultWall);
      return walls.concat(this.$app.userWalls);
    },
  },

  methods: {
    async onFileChange(e) {
      const file = e.target.files[0];

      if(!file) return;

      const base64 = await convertToBase64(file);

      console.log(this.walls);

      const newWall = {
        id: this.walls.length + 1,
        img: base64,
        thumb: base64,
        sizeRange: walls[0].sizeRange, // since we do not know the user wall size lets use one with default wall
        width: walls[0].width, // since we do not know the user wall size lets use one with default wall
        isUserWall: 1,
      };

      this.$app.userWalls.push(newWall);
      console.log({ newWall });

      this.$router.push({
        name: "artist.artwork.test",
        params: { wallId: newWall.id },
        query: { userWall: newWall.isUserWall },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.selected {
  border: 2px solid var(--v-primary-base);
  opacity: 0.6;
}
.thumbnail {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    transform: scale(0.96);
  }
}
form {
  height: 100%;
  min-width: 150px;
}
.dropbox {
  border: 2px dashed grey; /* the dash box */
  color: dimgray;
  padding: 10px 10px;
  position: relative;
  text-align: center;
  border-radius: 2px;
  display: flex;
  align-items: center;
  height: 100%;
  min-width: 150px;

  &:hover:not(.disabled) {
    background: #eaeaea; /* when mouse over to the drop zone, change color */
  }

  .disabled {
    opacity: 0.5;
  }

  p {
    margin-bottom: 0px;
    width: 100%;
    @media only screen and (max-width: 700px) {
      // font-size: 0.8rem;
    }
  }
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  border-radius: 10px;
  cursor: pointer;

  &:disabled {
    cursor: default;
  }
}
</style>

